import React from "react";
import { Form } from "../Form";
import { SectionHeader } from "../SectionHeader";
import { Submit } from "../Submit";
import { useTranslation } from "../hooks/useTranslation";
import { FormStateStatus } from "../utils/FormStateStatus";
import { FormButtons } from "./FormButtons";
export function DetailForm({ values, onSubmit, onCancel, onEdit, children, loading, title, saveState, isStatic = false, errorMessage, failedMessage, extra, editDisabled, saveDisabled, readOnly, messages, id, tooltip, hideCancel, submitLabel, dataId, dataTestId, }) {
    if (failedMessage) {
        messages = {
            ...messages,
            failed: failedMessage,
        };
    }
    if (errorMessage) {
        messages = {
            ...messages,
            errors: errorMessage,
        };
    }
    const t = useTranslation();
    return (React.createElement("div", { className: "detail-form", "data-id": dataId, "data-testid": dataTestId },
        React.createElement(Form, { values: values, onSubmit: onSubmit, loading: loading || saveState === "saving", isStatic: isStatic, id: id },
            React.createElement(SectionHeader, { title: `${title ? `${title} ` : ""}${t("Details")}`, tooltip: tooltip },
                extra && extra,
                !readOnly && (React.createElement(FormButtons, { viewState: isStatic ? "read" : "edit", onCancel: onCancel, onEdit: onEdit, saveState: saveState, id: id, editDisabled: editDisabled, hideCancel: hideCancel },
                    React.createElement(Submit, { inline: true, disabled: saveDisabled, id: id && `${id}__submit`, label: submitLabel })))),
            React.createElement(FormStateStatus, { saveState: saveState, messages: messages }),
            children)));
}
